import { EDIT_COMPONENT_TYPE } from '../../../constants/constants';

interface SidebarShadowCardProps {
  variant: EDIT_COMPONENT_TYPE.image_left_text_right | EDIT_COMPONENT_TYPE.text_left_image_right | EDIT_COMPONENT_TYPE.multi_image | EDIT_COMPONENT_TYPE.tip | EDIT_COMPONENT_TYPE.text_only;
  label: string;
  imageCount?: number;
  onClick?: () => void;
}

export function SidebarShadowCard({ variant, label, imageCount = 1, onClick }: SidebarShadowCardProps) {
  const isImageLeft = variant === EDIT_COMPONENT_TYPE.image_left_text_right;
  const isMultiImage = variant === EDIT_COMPONENT_TYPE.multi_image;
  const isTip = variant === EDIT_COMPONENT_TYPE.tip;
  const isTextOnly = variant === EDIT_COMPONENT_TYPE.text_only;
  
  if (isTip) {
    return (
      <div
        style={{
          background: "#232f3e",
          borderRadius: 11,
          width: 260,
          height: 58,
          color: "#fff",
          boxShadow: "0 2px 6px #0003",
          padding: 6,
          marginBottom: 22,
          cursor: "pointer",
          opacity: 0.92,
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        <div style={{ fontSize: 16 }}>💡</div>
        <div style={{ fontSize: 12, fontWeight: 600, textAlign: "center", lineHeight: 1.2 }}>
          Tip/Caution/<br/>Important
        </div>
      </div>
    );
  }
  
  if (isTextOnly) {
    return (
      <div
        style={{
          background: "#232f3e",
          borderRadius: 11,
          width: 260,
          height: 58,
          color: "#fff",
          boxShadow: "0 2px 6px #0003",
          padding: 6,
          marginBottom: 22,
          cursor: "pointer",
          opacity: 0.92,
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        <div style={{ fontSize: 20 }}>📝</div>
        <div style={{ fontSize: 14, fontWeight: 600 }}>Text Block</div>
      </div>
    );
  }
  
  if (isMultiImage) {
    return (
      <div
        style={{
          background: "#232f3e",
          borderRadius: 11,
          width: 260,
          height: 58,
          color: "#fff",
          boxShadow: "0 2px 6px #0003",
          padding: 6,
          marginBottom: 22,
          cursor: "pointer",
          opacity: 0.92,
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick?.();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Add ${label}`}
        title={label}
      >
        {Array.from({ length: imageCount }, (_, i) => (
          <div key={`img-${i}`} style={{ background: "#444", width: imageCount === 1 ? 48 : 32, height: 24, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 600 }}>Img</div>
        ))}
      </div>
    );
  }
  
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isImageLeft ? "54px 1fr" : "1fr 54px",
        gap: 14,
        alignItems: "center",
        background: "#232f3e",
        borderRadius: 11,
        width: 260,
        height: 58,
        color: "#fff",
        boxShadow: "0 2px 6px #0003",
        padding: 6,
        marginBottom: 22,
        cursor: "pointer",
        opacity: 0.92,
        userSelect: "none",
      }}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Add ${label}`}
      title={label}
    >
      {isImageLeft && (
        <div
          style={{
            background: "#444",
            width: 46,
            height: 38,
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          Img
        </div>
      )}
      <div>
        <div style={{ background: "#444", height: 8, borderRadius: 3, marginBottom: 7, width: "87%" }} />
        <div style={{ background: "#444", height: 7, borderRadius: 3, width: "66%" }} />
        <div style={{ background: "#444", height: 4, borderRadius: 3, width: "40%", margin: "6px auto 0 auto" }} />
      </div>
      {!isImageLeft && (
        <div
          style={{
            background: "#444",
            width: 46,
            height: 38,
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          Img
        </div>
      )}
    </div>
  );
}

export default SidebarShadowCard;
